import {Fragment} from 'react'
import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'
import {ForYouItemContent, ForYouVisual} from './ForYouItemContent'
import {LegacyForYouItem} from './ForYouItemLegacy'
import {
  isCanonicalForYouItemProps,
  type CanonicalForYouItemProps,
  type ForYouItemProps as ForYouItemPropsContract,
} from './for-you-item.types'
import {isForYouRefreshEnabled} from './for-you-feature-flags'

export type ForYouItemProps = ForYouItemPropsContract

export function ForYouItem(props: ForYouItemProps) {
  if (isCanonicalForYouItemProps(props)) {
    if (props.visual === undefined) {
      throw new Error('Canonical ForYouItem requires a visual')
    }
    if ('children' in props && props.children != null) {
      throw new Error('Canonical ForYouItem does not support children')
    }
    return isForYouRefreshEnabled() ? <ForYouItemContent {...props} /> : <CanonicalLegacyForYouItem {...props} />
  }

  return <LegacyForYouItem {...props} />
}

function CanonicalLegacyForYouItem({itemId, visual, title, subText, actions, footer}: CanonicalForYouItemProps) {
  const reducedMotion = usePrefersReducedMotion()
  const renderedActions = actions?.filter(action => action.content)

  return (
    <LegacyForYouItem
      itemName={itemId}
      title={title}
      description={subText}
      leadingVisual={<ForYouVisual visual={visual} reducedMotion={reducedMotion} />}
      emphasizedLeadingVisual
      fullWidthActionSlotOnNarrow
      variant="embedded"
      footer={footer}
      actionSlot={
        renderedActions?.length ? (
          <div className="d-flex flex-wrap gap-2">
            {renderedActions.map(action => (
              <Fragment key={action.id}>{action.content}</Fragment>
            ))}
          </div>
        ) : undefined
      }
    />
  )
}
